<script setup lang="ts">
import type { Challenge } from '~/types/challenge'

const { locale } = useI18n()

const props = defineProps<{
  challenge: Challenge
}>()

const note = computed(() => {
  if (!props.challenge) return

  return resolveChallengeField(props.challenge, 'note', locale.value)
})
</script>

<template>
  <RendererMarkdown v-if="note" :content="note" />
</template>
